<template>
    <Popper
        :class="this.smart_icon ? 'smart-icon' : ''"
        v-if="this.htmlContent"
        arrow
        :hover="this.hover"
        :placement="this.placement"
    > 
        <slot></slot>
        <template #content>
          <div v-if="this.hasHtmlTag" v-html="this.content"></div>
          <div v-else>{{ this.content }}</div>
        </template>
    </Popper>
    <Popper
        :class="this.smart_icon ? 'smart-icon' : ''"
        v-else-if="this.custom"
        arrow
        :hover="this.hover"
        :placement="this.placement"
    >
        <Icon name="info" size="c18" />
        <template #content>
          <div v-if="this.hasHtmlTag" v-html="this.content"></div>
          <div v-else>{{ this.content }}</div>
        </template>
    </Popper>
    <Popper
        v-else-if="this.small_icon"
        @open:popper="() => this.iconActive = true"
        @close:popper="() => this.iconActive = false"
        arrow
        :hover="this.hover"
        :placement="this.placement"
    >
        <Icon :active="this.iconActive" name="question" size="c22" />
        <template #content>
          <div v-if="this.hasHtmlTag" v-html="this.content"></div>
          <div v-else>{{ this.content }}</div>
        </template>
    </Popper>
    <Popper
        v-else
        @open:popper="() => this.iconActive = true"
        @close:popper="() => this.iconActive = false"
        arrow
        :hover="this.hover"
        :placement="this.placement"
    >
        <Icon :active="this.iconActive" name="question" size="c34 ml-1" />
        <template #content>
          <div v-if="this.hasHtmlTag" v-html="this.content"></div>
          <div v-else>{{ this.content }}</div>
        </template>
    </Popper>
</template>

<script>
import Popper from "vue3-popper";
import Icon from "@/components/icons/Icon.vue";
  export default {
    components: {
      Popper,
      Icon
    },
    props: {
        content: { 
          type: [String, Boolean],
          default: 'Some hint',
        },
        hover: {
          type: Boolean,
          default: true,
        },
        placement: {
          type: String,
          default: 'top',
        },
        custom: [String, Boolean],
        small_icon: {
          default: false,
          type: [Boolean],
        },
        smart_icon: {
          default: false,
          type: [Boolean],
        },
        htmlContent: {
          default: false,
          type: [Boolean]
        }
    },
    data() {
      return {
        iconActive: false,
      }
    },
    computed: {
      hasHtmlTag() {
        if (typeof this.content !== 'string') {
          return false;
        }
        const doc = new DOMParser().parseFromString(this.content, 'text/html');
        return Array.from(doc.body.childNodes).some(n => n.nodeType === 1);
      }
    },
  };
</script>

<style lang="scss">
    :root {
    --popper-theme-background-color: #333333;
    --popper-theme-background-color-hover: #333333;
    --popper-theme-text-color: #ffffff;
    --popper-theme-border-width: 2px;
    --popper-theme-border-style: solid;
    --popper-theme-border-radius: 6px;
    --popper-theme-border-color: #333333;
    --popper-theme-padding: 0.5rem;
    --popper-theme-box-shadow: 0 6px 30px -6px rgba(0, 0, 0, 0.25);
  }

  .smart-icon.inline-block {
    border: none!important;
    margin: 0!important;
    display: block!important;
  }

  .popper {
    max-width: 15rem;
    text-align: center;
    font-size: 16px;
    font-weight: normal;

    & #arrow {
      left: -4px!important;
    }

    a {
      color: $color-href !important;
    }
  }
</style>